( function( $ ) { 

	var Accordion = {};

	Accordion.do = function () {
		var btn = $( '.faq-item .fi-question a' );
		btn.click( function( e ) {
			e.preventDefault();
			var answer = $(this).parents( '.faq-item' ).find( '.fi-answer' );

			if ( $(this).parents('.faq-item').children( '.fi-answer' ).hasClass( 'expanded' ) ) {
				answer.removeClass( 'expanded' );
				answer.slideUp();
				$(this).text('Svar');
			} else {
				answer.addClass('expanded');
				answer.slideDown();
				$(this).text('Dolj');
			}

		} );
	};

	$( document ).ready( function() {
		Accordion.do();
	} );
	
} )( jQuery );